import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} Vendor
 * @property {string} id
 * @property {string} name
 * @property {string} description
 * @property {string} address_line_1
 * @property {string} address_line_2
 * @property {string} city
 * @property {string} state
 * @property {string} zip
 * @property {string} country_code
 * @property {string} phone
 * @property {string} email
 * @property {boolean} is_dropship
 * @property {string} dropship_template_id
 * @property {string} emails
 * @property {string} server
 * @property {string} username
 * @property {string} path
 * @property {string} password
 * @property {string} transmission_channel
 */

/**
 * @typedef {Object} VendorsSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {Object.<string, Vendor>} data
 */

export const VENDORS_ACTIONS = {
  SET_VENDOR: 'SET_VENDOR',
  SET_VENDORS: 'SET_VENDORS',
  SET_STATUS: 'SET_VENDORS_STATUS',
  SET_ERRORS: 'SET_VENDORS_ERRORS',
  CLEAR_ERRORS: 'CLEAR_VENDORS_ERRORS'
}

export const initialVendorsState = {
  status: 'idle',
  errors: [],
  data: {}
}

export const vendorsPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      address_line_1: PropTypes.string,
      address_line_2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string,
      country_code: PropTypes.string,
      phone: PropTypes.string,
      email: PropTypes.string,
      is_dropship: PropTypes.bool,
      dropship_template_id: PropTypes.string,
      emails: PropTypes.string,
      server: PropTypes.string,
      username: PropTypes.string,
      path: PropTypes.string,
      password: PropTypes.string,
      transmission_channel: PropTypes.string
    })
  )
}
